// @flow
import { media } from '~/core/utils/style';
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

const size = 3;
const margin = 0.5;

export const Container = styled.div`
    align-items: center;
    border: 1px solid ${p => p.theme.secondaryMedium};
    border-radius: 1em;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 1em;
    padding: 0;
    transition: 0.3s;

    &:hover {
        box-shadow: 0 0 0.5em 0 ${p => p.theme.secondaryMedium};
    }

    ${media.tablet`
		flex-wrap: nowrap;
        padding: ${margin}em;
	`};
`;

export const AttributeIcons = styled.div`
    display: flex;
    flex: 1 0 60%;
    margin-right: ${margin}em;
    max-width: ${3 * (size + 2 * margin)}em;
    order: 1;

    ${media.tablet`
		flex-basis: 0 0 auto;
	`};
`;

export const AttributeIconContainer = styled.div`
    background-color: ${p => p.theme.secondaryLight};
    border-radius: 100%;
    height: ${size}em;
    margin: ${margin * 0.7}em;
    position: relative;
    width: ${size}em;

    ${media.tablet`
        margin: ${margin}em;
    `};
`;

export const AttributeIcon = styled(SVGIcon)`padding: ${size * 0.1}em;`;

export const Description = styled.div`
    flex: 1 1 auto;
    margin: ${1.7 * margin}em;
    margin-top: ${0.5 * margin}em;
    order: 3;

    ${media.tablet`
        margin: 0 ${margin}em;
		order: 2;
	`};
`;

export const Control = styled.div`
    align-items: center;
    display: flex;
    flex: 1 0 30%;
    justify-content: flex-end;
    order: 2;

    ${media.tablet`
        flex: 0 0 ${3 * size}em;
		order: 3;
	`};
`;

export const ControlText = styled.div`font-size: 0.9em;`;

export const MoreIcon = styled(SVGIcon)`
    height: ${size * 0.7}em;
    margin: 0;
    width: ${size * 0.7}em;

    & > g {
        fill: ${p => p.theme.secondaryHeavy};
    }

    ${media.tablet`
        margin: ${margin}em;
	`};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/template/styles.js